import {
  CONTENT_LOGS_DIR_FETCH_REQUEST,
  CONTENT_LOGS_DIR_FETCH_SUCCESS,
  CONTENT_LOGS_DIR_FETCH_FAILURE,
  CONTENT_LOGS_FILE_FETCH_REQUEST,
  CONTENT_LOGS_FILE_FETCH_SUCCESS,
  CONTENT_LOGS_FILE_FETCH_FAILURE,
} from '../../types';

export interface IContentLogsState {
  entries: any[];
  currentFile: any | null;
  loading: boolean;
  error: string | null;
  currentPath: string;
}

const initialState: IContentLogsState = {
  entries: [],
  currentFile: null,
  loading: false,
  error: null,
  currentPath: '',
};

export default function contentLogsReducer(
  state = initialState,
  action: any
): IContentLogsState {
  switch (action.type) {
    case CONTENT_LOGS_DIR_FETCH_REQUEST:
      return { ...state, loading: true, error: null, currentFile: null };
    case CONTENT_LOGS_DIR_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        entries: action.payload?.entries || [],
        currentPath: action.payload?.path || '',
      };
    case CONTENT_LOGS_DIR_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CONTENT_LOGS_FILE_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case CONTENT_LOGS_FILE_FETCH_SUCCESS:
      return { ...state, loading: false, currentFile: action.payload };
    case CONTENT_LOGS_FILE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
